import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBanner} from "./BannerTypes"
import {
    IBannerPayload,
    IBannerTypeResponse,
    IBannersListParams,
    ICreateBannerResponse,
    IDeleteBannerParams,
    IUpdateBannerParams,
    IUploadAttachmentParams,
    IUploadAttachmentResponse
} from "./BannerApiTypes"

export const bannerApi = createApi({
    reducerPath: "bannerApi",
    baseQuery,
    tagTypes: ["banners"],
    endpoints: (build) => ({
        getBanners: build.query<IBasicResponse<IBanner[]>, IBannersListParams>({
            query: ({lang}) => ({
                url: "/v1/banners",
                method: "GET",
                headers: {
                    "Accept-Language": lang,
                    "X-Time-Zone": "Asia/Tashkent"
                }
            }),
            providesTags: ["banners"]
        }),
        getBannerTypes: build.query<IBasicResponse<IBannerTypeResponse[]>, Pick<IBannersListParams, "lang">>({
            query: ({lang}) => ({
                url: "/v1/banners/types",
                method: "GET",
                headers: {
                    "Accept-Language": lang,
                    "X-Time-Zone": "Asia/Tashkent"
                }
            })
        }),
        createBanner: build.mutation<IBasicResponse<ICreateBannerResponse>, IBannerPayload>({
            query: ({lang, ...body}) => ({
                url: "/v1/banners",
                method: "POST",
                headers: {
                    "Accept-Language": lang,
                },
                body
            }),
            invalidatesTags: ["banners"]
        }),
        updateBannerById: build.mutation<IBasicResponse<void>, IUpdateBannerParams>({
            query: ({lang, id, ...body}) => ({
                url: `/v1/banners/${id}`,
                method: "PUT",
                headers: {
                    "Accept-Language": lang,
                },
                body
            }),
            invalidatesTags: ["banners"]
        }),
        deleteBannerById: build.mutation<IBasicResponse<void>, IDeleteBannerParams>({
            query: ({lang, id}) => ({
                url: `/v1/banners/${id}`,
                method: "DELETE",
                headers: {
                    "Accept-Language": lang
                }
            }),
            invalidatesTags: ["banners"]
        }),
        uploadAttachment: build.mutation<IBasicResponse<IUploadAttachmentResponse>, IUploadAttachmentParams>({
            query: ({lang, file}) => {
                const formData = new FormData()
                formData.append("file", file)
                return {
                    url: "/v1/attachments",
                    method: "POST",
                    headers: {
                        "Accept-Language": lang
                    },
                    body: formData
                }
            }
        })
    })
})

export const {
    useGetBannersQuery,
    useGetBannerTypesQuery,
    useCreateBannerMutation,
    useUpdateBannerByIdMutation,
    useDeleteBannerByIdMutation,
    useUploadAttachmentMutation
} = bannerApi
